import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import breakpoints from '@bond/breakpoints';
import IconNavigation from '@shared/icon-navigation';
import Drawer from '@clearscore/rainbow.drawer';

import styles from './index.css';

const BurgerMenu = ({ initialIsOpen, routerTrackingSource, drawerDataId, onClose }) => {
    const [isOpen, setIsOpen] = useState(initialIsOpen);

    useEffect(() => {
        setIsOpen(initialIsOpen);
    }, [setIsOpen, initialIsOpen]);

    return (
        <Media query={breakpoints.l}>
            {(mediaMatches) => (
                <If condition={!mediaMatches}>
                    <Drawer
                        isCloseable
                        hasBackdrop
                        placement={Drawer.placements.LEFT}
                        theme={Drawer.themes.DARK}
                        dataId={drawerDataId}
                        isOpen={isOpen}
                        onClose={() => {
                            onClose();
                            setIsOpen(false);
                        }}
                    >
                        <div className={styles.content}>
                            <IconNavigation
                                menu="primary"
                                direction="vertical"
                                routerTrackingSource={routerTrackingSource}
                            />
                        </div>
                    </Drawer>
                </If>
            )}
        </Media>
    );
};

BurgerMenu.propTypes = {
    initialIsOpen: PropTypes.bool,
    onClose: PropTypes.func,
    routerTrackingSource: PropTypes.string,
    drawerDataId: PropTypes.string,
};

BurgerMenu.defaultProps = {
    initialIsOpen: false,
    onClose: () => {},
    routerTrackingSource: '',
    drawerDataId: '',
};

export default BurgerMenu;
